import { DriverProfile } from "./types"
const ACTIVE_DRIVERS_API_URL =
  "https://odin-kv.ai-a8c.workers.dev/?action=all_driver_ids"
const REVALIDATE_INTERVAL = 86400
type ActiveDriverResponse = { driver_ids: string[]; total: number }
let cachedDriverIds: { ID: string }[] | null = null
let lastFetchTime = 0
async function fetchActiveDriverIds(): Promise<{ ID: string }[]> {
  try {
    const response = await fetch(ACTIVE_DRIVERS_API_URL, {
      next: { revalidate: REVALIDATE_INTERVAL },
    })
    if (!response.ok) {
      throw new Error(`API responded with status ${response.status}`)
    }
    const data = (await response.json()) as ActiveDriverResponse
    if (!Array.isArray(data.driver_ids)) {
      throw new Error("API response does not contain an array of driver IDs")
    }
    return data.driver_ids.map((id) => ({ ID: id.toString() }))
  } catch (error) {
    console.error("Error fetching active driver IDs:", error)
    return []
  }
}
export async function getActiveDriverIds(): Promise<{ ID: string }[]> {
  const now = Date.now()
  if (cachedDriverIds && now - lastFetchTime < REVALIDATE_INTERVAL * 1000) {
    return cachedDriverIds
  }
  const driverIds = await fetchActiveDriverIds()
  if (driverIds.length > 0) {
    cachedDriverIds = driverIds
    lastFetchTime = now
  }
  return driverIds
}
export async function getRandomDriverIds(
  count: number = 12,
): Promise<string[]> {
  const allDriverIds = await getActiveDriverIds()
  if (allDriverIds.length === 0) {
    return []
  }
  const shuffled = [...allDriverIds].sort(() => 0.5 - Math.random())
  return shuffled
    .slice(0, Math.min(count, allDriverIds.length))
    .map((item) => item.ID)
}
